import React, { Component } from "react";
import { AppCard, createTabHeaderTemplate, PageLayout } from "../../components/ui";
import { TabPanel, TabView } from "primereact/tabview";
import { isKYCApproveAllowed, isKYCAssessAllowed } from "../../authGuard";
import ListBankTransfersOutgoing, { BankTransfersListType } from "./ListBankTransfersOutgoing";
import ListPaymentRequestsOutgoing from "./ListPaymentRequestsOutgoing";
import { Landmark } from "lucide-react";

interface ReviewBankTransfersOutgoingState {
    activeTabIndex: number;
}

export default class ReviewBankTransfersOutgoing extends Component<Record<string, never>, ReviewBankTransfersOutgoingState> {
    tabNames: string[] = ["Pending KYC Submissions", "KYC Submissions Under Review", "Closed KYC Submissions"];

    constructor(props: Record<string, never> | Readonly<Record<string, never>>) {
        super(props);

        this.state = {
            activeTabIndex: 0,
        };
    }

    render() {
        return (
            <PageLayout heading="OUTGOING BANK TRANSFERS" icon={Landmark}>
                                <AppCard className="mb-3">
                                    <AppCard.Body className="!p-0">
                                        <TabView
                                            activeIndex={this.state.activeTabIndex}
                                            onTabChange={(e) => {
                                                this.setState({ activeTabIndex: e.index });
                                            }}
                                        >
                                            {(isKYCAssessAllowed() || isKYCApproveAllowed()) && (
                                                <TabPanel
                                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                                    headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                                    header="All Bank Transfers"
                                                >
                                                    <ListBankTransfersOutgoing listType={BankTransfersListType.All} />
                                                </TabPanel>
                                            )}
                                            {isKYCApproveAllowed() && (
                                                <TabPanel
                                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                                    headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                                    header="Pending Review Bank Transfers"
                                                >
                                                    <ListBankTransfersOutgoing listType={BankTransfersListType.Pending} />
                                                </TabPanel>
                                            )}
                                            {isKYCApproveAllowed() && (
                                                <TabPanel
                                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                                    headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                                    header="Pending Visa Direct Reviews"
                                                >
                                                    <ListPaymentRequestsOutgoing />
                                                </TabPanel>
                                            )}
                                        </TabView>
                                    </AppCard.Body>
                                </AppCard>
            </PageLayout>
        );
    }
}
